import * as React from 'react'
import styled, { css } from "styled-components";
import IconButton from './IconButton';
import { WidgetMessengerEventType } from '../../../../types';
import { useSelector } from 'react-redux';
import { MOBILE_BREAKPOINT } from '../../../styles/breakpoints';
import { MessageHelper } from '../../../helpers';
import { AppState } from '../../../store';

const Container = styled(IconButton) <{ mobile: boolean }>`
  display: none;

  ${props => props.mobile && css`
    display: flex;
  `}
`

const CloseButton = () => {
  const mobile: boolean = useSelector<AppState>(state => Boolean(state?.application?.hostMobile)) as boolean

  const onClick = () => {
    MessageHelper.sendMessage({ type: WidgetMessengerEventType.CLOSE, });
  }

  return (
    <Container onClick={onClick} mobile={mobile}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.25 3.95L12.05 2.75L8 6.8L3.95 2.75L2.75 3.95L6.8 8L2.75 12.05L3.95 13.25L8 9.2L12.05 13.25L13.25 12.05L9.2 8L13.25 3.95Z" fill="currentColor"></path></svg>
    </Container>
  )
}

export default CloseButton